import {
  normalizeTrackerType,
} from './trackerTypes';

const normalizeText = (value = '') => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

const tokenize = (value = '') => new Set(
  normalizeText(value)
    .split(' ')
    .filter((token) => token.length > 2)
);

const getCandidateTitle = (candidate = {}) => (
  candidate.suggestedTrackerTitle
  || candidate.trackerTitle
  || candidate.title
  || candidate.summary
  || candidate.label
  || candidate.payload?.suggestedTrackerTitle
  || candidate.payload?.summary
  || candidate.payload?.label
  || ''
);

const getCandidateType = (candidate = {}) => (
  normalizeTrackerType(
    candidate.trackerType
    || candidate.type
    || candidate.payload?.trackerType
    || candidate.payload?.type
  )
);

const getTrackerTitle = (tracker = {}) => (
  tracker.title || tracker.name || tracker.summary || ''
);

const tokenOverlapScore = (left = '', right = '') => {
  const leftTokens = tokenize(left);
  const rightTokens = tokenize(right);

  if (!leftTokens.size || !rightTokens.size) return 0;

  const overlapCount = [...leftTokens]
    .filter((token) => rightTokens.has(token))
    .length;

  return overlapCount / Math.max(leftTokens.size, rightTokens.size);
};

export const scoreTrackerCandidateMatch = (tracker = {}, candidate = {}) => {
  const trackerTitle = normalizeText(getTrackerTitle(tracker));
  const candidateTitle = normalizeText(getCandidateTitle(candidate));

  if (!trackerTitle || !candidateTitle) return 0;

  const trackerType = normalizeTrackerType(tracker.type);
  const candidateType = getCandidateType(candidate);
  const typeMatches = trackerType && candidateType && trackerType === candidateType;

  if (trackerTitle === candidateTitle) return typeMatches ? 1 : 0.92;
  if (trackerTitle.includes(candidateTitle) || candidateTitle.includes(trackerTitle)) {
    return typeMatches ? 0.9 : 0.78;
  }

  const overlap = tokenOverlapScore(trackerTitle, candidateTitle);
  if (overlap <= 0) return 0;

  return Math.min(typeMatches ? overlap + 0.18 : overlap, 0.86);
};

export const findTrackerCandidateMatches = ({
  trackers = [],
  candidate = {},
  minimumScore = 0.72,
} = {}) => trackers
  .map((tracker) => ({
    tracker,
    score: scoreTrackerCandidateMatch(tracker, candidate),
  }))
  .filter((match) => match.score >= minimumScore)
  .sort((a, b) => b.score - a.score);

export const getBestTrackerCandidateMatch = (options = {}) => (
  findTrackerCandidateMatches(options)[0] || null
);
